import PlaceIcon from '../PlaceIcon'
import {ReactComponent as SliderIcon} from '../../slider-tool.svg';
import {ReactComponent as ManLookingAtPhoneIcon} from './Man_Looking_at_Phone_Cartoon_Vector.svg';
import {ReactComponent as ManTalking} from './Black_Man_Talking_on_the_Phone_Cartoon_Vector.svg';

const  CategoryHeader = (props) =>
  (<div className={`row py-3 justify-content-center tree-discrption
      ${props.curScreen !== "treeDiscrption"? "none-sm": ""}`}
    style={{'textAlign':"left", background:"",    borderBottom: "1px solid gainsboro"}}>
    <div className="col-9 py-5 pl-5">
          <a href="#" className="tree-discrption-title">
          <div style={{textAlign:""}}>
            {"Find The Perfect Phone For You"}
            </div>
          </a>
        <div className="row justify-content-start text-muted" style={{fontSize: "18px"}}>
            <div className="col-auto pt-2">
              <span className="left bollit" style={{width:"20px",height:"20px"}}>
                <SliderIcon/>
              </span>
                <span style={{paddingLeft:"20px"}}>
                  {"Set Your Prefernces"}
                </span>
              </div>
            <div className="col-auto pt-2">
              <span className={"bollit"} style={{color:"#007bff"}}>
                {"91"}
              </span>
              <span style={{paddingLeft:"20px"}}>
                {"We Will Calculate Your Weighted Index"}
              </span>
            </div>
            <div className="col-auto pt-2">
              <span className={"bollit"}>
                <PlaceIcon index={0} size={30}/>
              </span>
              <span style={{paddingLeft:"20px"}}>
                {"Find The Right Choice For You"}
              </span>
            </div>
            </div>
          </div>
          <div className="col-2">
            <ManTalking style={{height:"200px", marginLeft:"-100px"}}/>
          </div>
          </div>)



export default CategoryHeader;
